import styled from "styled-components";

import { Container, FlexDiv, Image } from "../.././../components/Atoms";
import Typography from "../../../foundation/Typography/V2";
import { SliderWrapper } from "../../../components/Organisms/Testimonials/style";

export const Wrapper = styled(FlexDiv)`
  padding: 64px 0;
  @media only screen and (max-width: 1079px) {
    padding: 16px;
  }
`;

export const TestimonialContainer = styled(Container)`
  .slick-slide > div {
    margin: 0;
  }
  .slick-slide {
    margin: 0 40px 0 0;
  }
  .slick-slide:last-child {
    margin: 0;
  }
  .slick-slider .slick-list {
    padding: 48px 0 0;
  }
  .slick-prev,
  .slick-next {
    top: -26px;
    @media only screen and (max-width: 1024px) {
      top: -18px;
      height: 20px;
      width: 20px;
    }
  }
  .slick-prev {
    @media only screen and (max-width: 1024px) {
      right: 38px;
    }
  }
  @media only screen and (max-width: 1024px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const HeadingWrapper = styled(FlexDiv)`
  padding: 8px 0;
  @media only screen and (max-width: 1079px) {
    width: 100%;
    max-width: calc(100% - 90px);
  }
`;

export const Heading = styled(Typography)`
  margin: 0;
  color: ${({ theme }) => theme.colorsV2.shyft.purple_text};
`;

export const CardWrapper = styled(FlexDiv)`
  display: flex !important;
  flex-direction: column;
`;

export const SlickWrapper = styled(SliderWrapper)`
  margin: 0;
`;

export const StyledImage = styled(Image)`
  height: 48px;
  width: 48px;
`;

export const Title = styled(Typography)`
  margin: 8px 0;
`;

export const Description = styled(Typography)``;
